
		<ng-container #modalContent></ng-container>
  


// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-webapp-compat/webapp/src/app/@shared/ui/modal/modal.component.ts.ModalComponent.html